import { StarBoxOutlineIcon } from './StarBoxOutlineIcon';

/**
 * author: Austin Andrews
 * id B22FEE66-3EC9-466A-9014-EF53030FA3D9
 * name star-box-outline
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-box-outline.svg
 * tags
 */
export const FavoriteBoxOutlineIcon = StarBoxOutlineIcon;
export default FavoriteBoxOutlineIcon